import { MODAL_CONFIRMATION_STATE_DELAY } from '../../constants';

import templateUrl from './ConfirmationModalService.html';

export default class ConfirmationModalService {
  constructor($uibModal, $timeout) {
    'ngInject';

    Object.assign(this, { $uibModal, $timeout });
  }

  open({ title, subtitle, type = 'success' }) {
    const modal = this.$uibModal.open({
      templateUrl,
      size: '500',
      windowClass: 'window-confirmation-modal',
      controllerAs: 'ctrl',
      controller() {
        Object.assign(this, { title, subtitle, type });
      },
    });

    this.$timeout(modal.close, MODAL_CONFIRMATION_STATE_DELAY);

    return modal.result;
  }
}
